import type { IconSvgObject } from './types';

const FunnelPlusIcon: IconSvgObject = [
  ["path", { d: "M12.9115 2.5H3.08845C2.48732 2.5 2 2.98732 2 3.58845C2 3.85366 2.09682 4.10973 2.27229 4.30859L9.5 12.5V20.75C9.5 21.1642 9.83579 21.5 10.25 21.5C10.4123 21.5 10.5702 21.4474 10.7 21.35L14.1 18.8C14.3518 18.6111 14.5 18.3148 14.5 18V12.5L15.5 11.3667", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.995 2.5V8.5M22 5.495L16 5.495", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FunnelPlusIcon;
